import {
  ITennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { LiveScoreSubscriptionData } from "../types";
import { intcmpMap } from "../../../utils/intcmp";
import { UpdateLiveScoreWidgetInputSchema } from "cdk/graphql";
import { isValidLiveScoreSubscription } from "./typeguards";


export const transformSubscription = (obj: LiveScoreSubscriptionData): Omit<ITennisLiveScore, 'ctaUrls'> => {
  if (isValidLiveScoreSubscription(obj)) {
    UpdateLiveScoreWidgetInputSchema().parse(obj.data.onUpdateLiveScoreById, { reportInput: true });
    const { liveTournaments } = obj?.data?.onUpdateLiveScoreById;

    return {
      liveTournaments,
      resultsIntcmp: intcmpMap.liveScoreAtpResults,
    } as Omit<ITennisLiveScore, 'ctaUrls'>;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LiveScoreSubscription object',
      data: obj
    });
  }
};